import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import arData from "../i18n/ar.json";
import Logo from "../components/Logo";

// This page is Spanish-only per requirements
export default function ThankYou() {
  const t = (k) => k.split(".").reduce((a, kk) => (a && a[kk] !== undefined ? a[kk] : ""), arData);
  return (
    <div className="min-h-screen bg-[#f6f4ee] flex flex-col" data-testid="thankyou-page" lang="es-AR">
      <header className="px-5 sm:px-8 lg:px-14 py-6">
        <Link to="/" data-testid="thankyou-brand-home">
          <Logo />
        </Link>
      </header>

      <main className="flex-1 flex items-center">
        <div className="max-w-[1200px] mx-auto w-full px-5 sm:px-8 lg:px-14 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="lg:col-span-7"
            >
              <div className="eyebrow mb-8">{t("thankyou.eyebrow")}</div>
              <h1 className="font-serif tracking-tight leading-[1.02] text-[clamp(2.5rem,7vw,5.6rem)] text-[#1a211c]">
                {t("thankyou.title")}
              </h1>
              <p className="mt-8 text-[1.05rem] leading-relaxed text-[#1a211c]/75 max-w-xl">
                {t("thankyou.text")}
              </p>

              <div className="mt-10 flex items-center gap-4 flex-wrap">
                <Link to="/" className="btn-olive" data-testid="thankyou-back-btn">
                  <ArrowLeft size={16} />
                  {t("thankyou.back")}
                </Link>
                <span className="font-mono text-[0.78rem] tracking-[0.24em] text-[#3d4f42] uppercase">
                  — {t("thankyou.signature")}
                </span>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 1.02 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
              className="lg:col-span-5"
            >
              <div className="relative aspect-[4/5] rounded-sm overflow-hidden bg-[#1a211c] clip-arch">
                <img
                  src="https://images.unsplash.com/photo-1678838032358-d5ef71b283db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                  alt="Buenos Aires skyline"
                  className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 hero-spot" />
                <div className="absolute inset-0 p-6 flex items-end text-[#f6f4ee]">
                  <div>
                    <div className="text-[0.7rem] font-mono tracking-[0.28em] text-[#c5b293]">
                      ARG · 2026
                    </div>
                    <div className="font-serif text-2xl mt-1">Mirexilora</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </main>

      <footer className="px-5 sm:px-8 lg:px-14 py-6 text-[0.78rem] text-[#1a211c]/50 font-mono">
        © 2026 Mirexilora S.A.S.
      </footer>
    </div>
  );
}
